import { notification } from "antd"
import { useMutation, useQuery } from "react-query"
import { getQuickBooksAuthorize, getQuickBooksConnectionStatus, getQuickBooksDisconnect, getQuickBooksSalesTaxes } from "./quickBooksApi"
import { QuickBooksAuthorize } from "./quickBooksModel"

export const useQuickBooksAuthorizeQuery = (onSuccess: (data: QuickBooksAuthorize) => void) => {
  return useMutation({
    mutationFn: () => getQuickBooksAuthorize(),
    onSuccess: (data: QuickBooksAuthorize) => {
      onSuccess(data)
    },
    onError: () => {
      notification.error({ message: 'There was an error redirecting to QuickBooks. Please try again later.' })
    }
  })
}

export const useQuickBooksDisconnectMutation = (onSuccess: () => void) => {
    return useMutation({
      mutationFn: () => getQuickBooksDisconnect(),
      onSuccess: () => {
        onSuccess()
      },
      onError: () => {
        notification.error({ message: 'There was an error disconnecting from QuickBooks. Please try again later.' })
      }
    })
}

export const useQuickBooksConnectionStatus = () => {
  return useQuery(['quickBooksConnectionStatus'], getQuickBooksConnectionStatus)
}

export const useQuickBooksDisconnect = () => {
  return useQuery(['quickBooksDisconnect'], getQuickBooksDisconnect)
}

export const useQuickBooksSalesTaxesQuery = (isTenantLinkedtoQboUsaAccount: boolean) => {
  return useQuery(['quickBooksSalesTaxes'], getQuickBooksSalesTaxes, {
    enabled: isTenantLinkedtoQboUsaAccount
  })
}